import { render, staticRenderFns } from "./Reverify.vue?vue&type=template&id=10906cb8&scoped=true&lang=true&"
import script from "./Reverify.vue?vue&type=script&lang=js&"
export * from "./Reverify.vue?vue&type=script&lang=js&"
import style0 from "./Reverify.vue?vue&type=style&index=0&id=10906cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10906cb8",
  null
  
)

export default component.exports